import React from 'react'
import "./footer.css"
import copyright from "../assest/imgs/copyright.png"

const Footer = () => {
  return (
    <footer>
       <div className="logo">
           <h2>TecnoBlog</h2>
        </div>
        <div className='copyRight'>
           <img className="copyright" src={copyright} alt=''/>
           <span>
              Developed by Yusra AlRahbi
           </span>
        </div>
    </footer>
  )
}

export default Footer